<template>
  <a-modal
    width="588px"
    v-model:visible="visible"
    :title="modalTitle"
    centered
    @ok="handleOk"
    @cancel="closeModal"
  >
    <a-form :rules="rules" ref="formRef" v-bind="layout" :model="formState" class="form">
      <a-form-item name="classifyId" label="话术分类">
        <a-tree-select
          style="width: 240px"
          placeholder="请选择话术分类"
          :tree-data="classifyData"
          :replaceFields="{ children: 'listNode', title: 'phraseName', key: 'id', value: 'id' }"
          v-model:value="formState.classifyId"
        />
      </a-form-item>
      <a-form-item name="chatContent" label="话术内容">
        <a-textarea
          placeholder="请输入话术内容"
          style="width: 400px"
          :maxlength="100"
          :autoSize="{ minRows: 6, maxRows: 8 }"
          showCount
          v-model:value="formState.chatContent"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { defineComponent, ref, reactive } from 'vue'
import { addPhraseClassify, getLeftTree } from '@/api/Speach/index.js'
import { findNode } from '@/utils/index'
import { message } from 'ant-design-vue'

export default defineComponent({
  name: 'Upload',
  setup(props, { emit }) {
    const formRef = ref(null)
    const classifyData = ref([])
    const visible = ref(false)
    const modalTitle = ref('添加话术')
    let formState = reactive({
      classifyId: null,
      chatContent: null,
      id: null,
      phraseName: null,
      phraseLevel: null
    })
    const rules = {
      classifyId: [
        { required: true, message: '请选择话术分类', trigger: 'change', type: 'number' }
      ],
      chatContent: [
        { required: true, message: '请输入话术内容', trigger: 'change', type: 'string' }
      ]
    }
    const showModal = record => {
      visible.value = true
      leftTree(record)
    }
    const handleOk = () => {
      formRef.value.validate().then(() => {
        const data = findNode(classifyData.value, 'listNode', node => {
          return node.id === formState.classifyId
        })
        const { phraseName, phraseLevel } = data || {}
        addPhraseClassify({ ...formState, phraseLevel, phraseName }).then(() => {
          emit('getPageList')
          message.success('保存成功')
          modalTitle.value = '添加话术'
          visible.value = false
          formRef.value.resetFields()
          formState = Object.assign(formState, {
            classifyId: null,
            chatContent: null,
            id: null,
            phraseName: null,
            phraseLevel: null
          })
        })
      })
    }
    const closeModal = () => {
      visible.value = false
      formRef.value.resetFields()
      formState = Object.assign(formState, {
        classifyId: null,
        chatContent: null,
        id: null,
        phraseName: null,
        phraseLevel: null
      })
    }
    //获取话术分类数据
    const leftTree = record => {
      getLeftTree().then((res = []) => {
        classifyData.value = [...res]
        if (record) {
          modalTitle.value = '编辑话术'
          const { id, phraseName, phraseLevel, chatContent, classifyId } = record
          formState = Object.assign(formState, {
            id,
            phraseName,
            phraseLevel,
            chatContent,
            classifyId
          })
        }
      })
    }
    return {
      modalTitle,
      classifyData,
      visible,
      formRef,
      rules,
      layout: { labelCol: { span: 4 }, wrapperCol: { span: 14 } },
      formState,
      closeModal,
      showModal,
      handleOk
    }
  }
})
</script>
<style lang="scss" scoped>
.form {
  ::v-deep(.ant-form-item) {
    margin-bottom: 16px;
  }
  .uploadTips {
    font-size: 12px;
    color: #8c8c8c;
    padding-bottom: 8px;
    margin: 0;
  }
  .downLoad {
    width: 230px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    ::v-deep(.ant-btn) {
      padding: 0;
      font-size: 12px;
    }
    .label {
      font-size: 14px;
      color: #333333;
    }
  }
  .errorTips {
    font-size: 12px;
    color: #ff4848;
    display: flex;
    align-items: center;
  }
}
</style>
